import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import * as React from 'react';
import { LedgerRecord, LedgerRecordData } from '../types';
import { formatPostgresDate, generateTable, log, TableProperties } from '../utils';
interface Props {
  data: LedgerRecordData | undefined;
}

interface LedgerRecordTableDataRow {
  created: string;
  projectName: string;
  issueCode: string;
  description: string;
  userName: string;
}

const columnCreatedWidth = 110;
const projectNameWidth = 120;
const projectTypeWidth = 80;
const issueCodeWidth = 50;
const userNameWidth = 60;
const columnDescriptionWidth = 280;

export type LedgerRecordTableDataRows = LedgerRecordTableDataRow[];

const ledgerRecordTransformData = (data: LedgerRecordData): LedgerRecordTableDataRows => {
  // spread all props and leave columns do it's magic
  return data.records.map((e: LedgerRecord) => {
    return {
      ...e,
      created: formatPostgresDate(e.created),
      projectName: `${e.projectName} v${e.projectVersion} (${e.branch})`,
    };
  });
};

export const LedgerTableComponent: React.FC<Props> = ({ data }) => {
  // configure table for ledgerRecords
  const style = { verticalAlign: 'top' };
  let ledgerRecordTableProperties: TableProperties<LedgerRecordTableDataRows> = {
    columns: {
      created: { title: 'created', props: { style, width: columnCreatedWidth } },
      projectName: { title: 'project/version/branch', props: { style, width: projectNameWidth } },
      projectType: { title: 'type', props: { style, width: projectTypeWidth } },
      issueCode: { title: 'Issue code', props: { style, width: issueCodeWidth } },
      userName: { title: 'User', props: { style, width: userNameWidth } },
      description: { title: 'Description', props: { style, width: columnDescriptionWidth } },
    },
  };
  let ledgerRecordTableHeadRows: JSX.Element[] = [];
  let ledgerRecordTableDataRows: JSX.Element[] = [];
  if (data) {
    // extend tableProperties with transformed data
    ledgerRecordTableProperties = { ...ledgerRecordTableProperties, data: ledgerRecordTransformData(data) };
    // override defaults
    ({ tableHeadRows: ledgerRecordTableHeadRows, tableDataRows: ledgerRecordTableDataRows } = generateTable<LedgerRecordTableDataRows>(ledgerRecordTableProperties));
  }

  return (
    <>
      <TableContainer>
        <Table aria-label='simple table'>
          <TableHead>
            <TableRow>{ledgerRecordTableHeadRows}</TableRow>
          </TableHead>
          <TableBody>{ledgerRecordTableDataRows}</TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
